"use strict";

define('service/authority',['require','exports','module','appkit/service','rs/models/session','../config'],function (require, exports, module) {
  'use strict';

  var Service = require('appkit/service'),
    Session = require('rs/models/session'),
    config = require('../config');
  var AUTHORITIES_FIELD = 'authorities';
  var FEATURES_FIELD = 'feature';
  var USERS_FIELD = 'users';
  var USER_AUTHORITY_FIELD = 'authority';
  var AuthorityService = Service.extend({
    events: {
      'authenticated': 'onAuthenticated'
    },
    replies: {
      'check:authority': 'userHasAuthority',
      'check:feature': 'userHasFeature',
      'filterNavigationList': 'filterNavigationList'
    },
    getAuthoritiesFromUser: function getAuthoritiesFromUser(user) {
      return _.pluck(user.authorities, USER_AUTHORITY_FIELD);
    },
    getFeaturesFromUser: function getFeaturesFromUser(user) {
      return user.features;
    },
    onAuthenticated: function onAuthenticated(user) {
      this.currentUser = user;
    },
    userHasFeature: function userHasFeature(feature) {
      var features = this.currentUser.features;
      if (_.isArray(feature)) {
        if (_.isEmpty(feature)) {
          return true;
        }
        return _.any(feature, function (f) {
          return !!features[f];
        });
      } else {
        return !!features[feature];
      }
    },
    userHasAuthority: function userHasAuthority(authority) {
      var user = this.currentUser;
      if (!user) {
        throw new Error('User not authenticated.');
      }
      var userAuthorities = _.pluck(user.authorities, USER_AUTHORITY_FIELD);
      if (_.isArray(authority)) {
        if (_.isEmpty(authority)) {
          return true;
        }
        return _.any(authority, function (a) {
          return userAuthorities.indexOf(a) > -1;
        });
      } else {
        return _.contains(userAuthorities, authority);
      }
    },
    filterNavigationList: function filterNavigationList(list, user) {
      user = user || this.currentUser;
      list = this.filterNavigationByAuthorities(list, user);
      list = this.filterNavigationByFeature(list, user);
      list = this.filterNavigationByUsers(list, user);
      list = this.filterNavigationByFeatureFlag(list);
      return list;
    },
    filterNavigationByAuthorities: function filterNavigationByAuthorities(list, user) {
      var userAuthorities = this.getAuthoritiesFromUser(user),
        hasAuthority = false,
        authorities = [];
      return _.filter(list, function (item) {
        hasAuthority = false;
        authorities = item[AUTHORITIES_FIELD] || [];
        if (_.isEmpty(authorities)) {
          hasAuthority = true;
        }
        for (var i = 0, len = authorities.length, authority; i < len; i++) {
          authority = authorities[i];
          if (_.indexOf(userAuthorities, authority) >= 0) {
            hasAuthority = true;
            break;
          }
          ;
        }
        if (hasAuthority && item.children) {
          item.children = this.filterNavigationByAuthorities(item.children, user);
        }
        return hasAuthority;
      }, this);
    },
    filterNavigationByFeature: function filterNavigationByFeature(list, user) {
      var userFeatures = this.getFeaturesFromUser(user);
      return _.filter(list, function (item) {
        var requiredFeature = item[FEATURES_FIELD];
        if (!requiredFeature || userFeatures[requiredFeature]) {
          if (item.children) {
            item.children = this.filterNavigationByFeature(item.children, user);
          }
          return true;
        }
      }, this);
    },
    filterNavigationByUsers: function filterNavigationByUsers(list, user) {
      var isUser = false,
        users = [];
      return _.filter(list, function (item) {
        isUser = false;
        users = item[USERS_FIELD] || [];
        if (_.isEmpty(users)) {
          isUser = true;
        }
        for (var i = 0, len = users.length; i < len; i++) {
          if (users[i] === user.userName) {
            isUser = true;
            break;
          }
        }
        if (isUser && item.children) {
          item.children = this.filterNavigationByUsers(item.children, user);
        }
        return isUser;
      }, this);
    },
    filterNavigationByFeatureFlag: function filterNavigationByFeatureFlag(list) {
      var isOneLogin = Session.isOneLogin(),
        keepIt = false,
        featureFlags = [];
      if (!isOneLogin) return list;
      return _.filter(list, function (item) {
        keepIt = false;
        featureFlags = item.featureFlag || [];
        keepIt = featureFlags.indexOf('legacyAdmin') === -1;
        if (keepIt && item.children) {
          item.children = this.filterNavigationByFeatureFlag(item.children);
        }
        return keepIt;
      }, this);
    }
  });
  module.exports = AuthorityService;
});

